import { Icon } from '@capsico/ui';

/** Top-of-home "Deliver to" control: place label + street line, tap to change. */
export function LocationBar({
  caption,
  label,
  line,
  onOpen,
}: {
  caption: string;
  label: string;
  line: string | null;
  onOpen: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex min-w-0 flex-1 items-center gap-2 text-left"
    >
      <span className="inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand-ink">
        <Icon name="pin" size={18} />
      </span>
      <span className="min-w-0">
        <span className="block text-micro font-semibold tracking-[0.06em] text-ink-3 uppercase">
          {caption}
        </span>
        <span className="flex items-center gap-1 text-sm font-bold text-ink">
          <span className="truncate">{label}</span>
          <Icon name="chevron-down" size={16} />
        </span>
        {line && <span className="block truncate text-xs text-ink-2">{line}</span>}
      </span>
    </button>
  );
}
